import React, { FC } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { i18n } from '../../../../../symphony';
import { ILPGoogleHireData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './GoogleHire.scss';

type Props = {
  data: ILPGoogleHireData;
  alias: string;
};

export const GoogleHire: FC<Props> = ({ data, alias }) => {
  useStyles(s);
  return (
    <div className="google-hire">
      <div className="google-hire__container">
        <div className="google-hire__image-container">
          <img
            className="google-hire__image"
            src={data.imgUrl}
            alt=""
          />
        </div>
        <div className="google-hire__content">
          <h4
            className="google-hire__title"
            dangerouslySetInnerHTML={{
              __html: i18n.t(
                `web-lelp.${alias}-google-hire-title`,
              ),
            }}
          />
          <p
            className="google-hire__description"
            dangerouslySetInnerHTML={{
              __html: i18n.t(
                `web-lelp.${alias}-google-hire-description`,
              ),
            }}
          />
          <a className="google-hire__button-container">
            <Button
              className="google-hire__button"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              {i18n.t(
                `web-lelp.${alias}-google-hire-button-text`,
              )}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};
